<div class="rm-details">
  <div class="rm-header">
    <!--@if (compData?.container?.roomContainers?.length > 1) {
      <div class="filter-cls">
        <div>
          <div class="room-title">Room Types</div>
        </div>
        <select
          [(ngModel)]="scrollToRoom"
          (ngModelChange)="gotoRoom($event)"
          class="filter-sel"
        >
          <option [ngValue]="null">Please select</option>
          @for (option of compData?.container?.roomContainers; track option) {
            <option [ngValue]="option">
              {{
                option?.roomPlanData?.channelManagerDisplayCategory | titlecase
              }}
            </option>
          }
        </select>
      </div>
    }-->

    <ng-container *ngTemplateOutlet="roomTypeFilterTemplate"></ng-container>

    <ng-container *ngTemplateOutlet="ratePlanFilterTemplate"></ng-container>

  </div>
  <div class="rm-dt-inr-wp">
    @for (roomData of compData?.container?.roomContainers;
      track roomData;
      let roomIndex = $index) {
      <ng-container
        *ngTemplateOutlet="
          roomCardTemplate;
          context: {
            roomData: roomData,
            roomIndex: roomIndex,
            cardStyle: 'all-rooms',
          }
        "
      ></ng-container>
    }
  </div>
</div>

<ng-template
  #roomCardTemplate
  let-roomData="roomData"
  let-roomIndex="roomIndex"
  let-cardStyle="cardStyle"
  let-isFullDetail="isFullDetail"
>
  <div class="rm-data" id="{{ roomData?.key }}"
       [ngClass]="{
                  'd-none':
                    emptyRooms?.length > 0 &&
                    emptyRooms?.includes(roomData?.key),
                }"
  >
    <div class="rm-title">
      {{
        roomData?.roomPlanData?.channelManagerDisplayCategory
          | displayCategoryPipe
          | titlecase
      }}
    </div>
    <div class="property-data">
      <div class="property-wrap lt-data">
        <div class="rcd">
          <div class="rm-img-wrap">
            <div class="rm-img" (click)="openRoomViewDetail(roomData, roomIndex, isFullDetail)">
              <input
                type="number"
                [hidden]="true"
                #selectedImageCount
                [value]="0"
              />
              <app-b2b-drag-scroll [config]="swiperConfig">
                @for (roomImage of roomData?.roomPlanData?.roomImages;
                  let index = $index;
                  track roomImage?.path) {
                  <app-b2b-drag-scroll-item [config]="swiperConfig">
                    <div class="pty-rm-img">
                      <img
                        [ngSrc]="
                          roomImage?.path +
                          '?format=webp&quality=' +
                          imgQuality +
                          '&height=' +
                          imgHeight
                        "
                        [alt]="roomImage?.alt"
                        width="100"
                        height="100"
                      />
                    </div>
                  </app-b2b-drag-scroll-item>
                }
              </app-b2b-drag-scroll>
            </div>
          </div>
          <div class="rm-amen">
            <ng-container
              *ngTemplateOutlet="
                roomAndPropertyTemplate;
                context: { roomData: roomData, isFullDetail: isFullDetail }
              "
            ></ng-container>

            @if (!isFullDetail) {
              <div class="vw-det">
                <div class="vd-btn"
                     (click)="openRoomViewDetail(roomData, roomIndex, isFullDetail)">
                  View Details
                </div>
              </div>
            }

            @if (roomData?.roomPlanData?.availableRooms > 0 &&
            roomData?.roomPlanData?.availableRooms < 2) {
              <div class="rp-err">
                <span
                >Only {{ roomData?.roomPlanData?.availableRooms }}
                  {{
                    roomData?.roomPlanData?.channelManagerDisplayCategory
                      | displayCategoryPipe
                      | titlecase
                  }}
                  Available</span
                >
              </div>
            }
          </div>
        </div>
      </div>
      <div class="property-wrap rt-data">
        <div class="rp-dt">
          @for (ratePlan of roomData?.ratePlanData;
            track ratePlan;
            let ratePlanIndex = $index) {
            <div class="rp-lp" [ngClass]="{
                  'd-none':
                    selectedRatePlanFilter?.key &&
                    selectedRatePlanFilter?.key !== ratePlan?.ratePlanType &&
                    (!ratePlan?.selectedRooms || ratePlan?.selectedRooms?.length === 0)
                }">
              <div class="rp-rm-dt">
                <div class="rp-rm-dt-wrap">
                  <div class="rp-rm-opt">
                    <div class="rm-dta-flex">
                      <div class="rm-flx-col">
                        <div class="credit-plan-sec">
                          @if (ratePlan?.promotionData?.redeemCreditPointPromotion
                            ?.title) {
                            <div class="credit-plan-promo">
                              <app-text-clamp-shell
                                [config]="{
                                  data: ratePlan?.promotionData
                                    ?.redeemCreditPointPromotion?.title,
                                  row: 2,
                                }"
                              >
                              </app-text-clamp-shell>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="rm-flx-col">
                        <div class="rm-pln-dt-inner">
                          <div class="rp-nm"
                               [ngClass]="{
                              'rp-nm-full': ratePlan?.entireProperty,
                            }"
                          >
                            <span class="room-title">{{ ratePlan?.displayCategory }}</span>
                            @if (ratePlan?.entireProperty) {
                              <span class="entire-room">
                                Entire {{ ratePlan?.entityTitle | titlecase }}
                              </span>
                            }
                          </div>
                          <!-- Rate plan option starts -->
                          @for (selectedRoom of ratePlan?.selectedRooms;
                            track selectedRoom;
                            let selectedRoomIndex = $index) {
                            <div class="sl-rm">
                              <div class="rm-btn-wrap">
                                <div class="rm-btn">
                                  <div class="rm-lt">
                                    {{ selectedRoom?.entityTitle | titlecase }}
                                    <span
                                    >(Unit {{ selectedRoomIndex + 1 }})</span
                                    >
                                  </div>
                                  <app-room-guest-form
                                    [compData]="{
                                      selectedRoom: selectedRoom,
                                      roomData: roomData,
                                      ratePlan: ratePlan,
                                    }"
                                    (selected)="
                                      onSelectGuestAndChild(
                                        $event,
                                        roomData,
                                        selectedRoom,
                                        ratePlan,
                                        ratePlanIndex,
                                        selectedRoomIndex
                                      )
                                    "
                                  ></app-room-guest-form>
                                  <div class="bin-wrap">
                                    @if (ratePlan?.selectedRooms?.length > 1) {
                                      <a
                                        class="del-img"
                                        href="javascript:void(0)"
                                        (click)="
                                          removeSingleRoomInRatePlan(
                                            roomData,
                                            ratePlan,
                                            selectedRoomIndex
                                          )
                                        "
                                      >
                                        <svg
                                          fill="#ce0000"
                                          x="0px"
                                          y="0px"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            d="M 10 2 L 9 3 L 5 3 C 4.4 3 4 3.4 4 4 C 4 4.6 4.4 5 5 5 L 7 5 L 17 5 L 19 5 C 19.6 5 20 4.6 20 4 C 20 3.4 19.6 3 19 3 L 15 3 L 14 2 L 10 2 z M 5 7 L 5 20 C 5 21.1 5.9 22 7 22 L 17 22 C 18.1 22 19 21.1 19 20 L 19 7 L 5 7 z M 9 9 C 9.6 9 10 9.4 10 10 L 10 19 C 10 19.6 9.6 20 9 20 C 8.4 20 8 19.6 8 19 L 8 10 C 8 9.4 8.4 9 9 9 z M 15 9 C 15.6 9 16 9.4 16 10 L 16 19 C 16 19.6 15.6 20 15 20 C 14.4 20 14 19.6 14 19 L 14 10 C 14 9.4 14.4 9 15 9 z"
                                          ></path>
                                        </svg>
                                      </a>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          @if (ratePlan?.selectedRooms?.length > 0) {
                            <div class="add-rm-dt">
                              <button
                                (click)="
                                  addNewRoom(
                                    roomData,
                                    ratePlan,
                                    ratePlanIndex,
                                    roomIndex
                                  )
                                "
                                [disabled]="roomData?.disableAddRoom || roomData?.disableOnlyAddRoom"
                                class="add-rm-btn"
                              >
                                + Add {{ ratePlan?.entityTitle | titlecase }}
                              </button>
                            </div>
                          }
                          <!-- Rate plan option ends -->
                        </div>

                        @if (ratePlan?.vendorOfferings?.length > 0) {
                          <div class="ratePlanOfr">
                            @for (vendorOffering of ratePlan?.vendorOfferings;
                              track vendorOffering) {
                              <div class="desc">
                                <div>
                                  <svg width="12px" height="12px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                                       fill="none" stroke="#179b4c" stroke-linecap="round" stroke-linejoin="round"
                                       stroke-width="1.5">
                                    <polyline points="2.75 8.75,6.25 12.25,13.25 4.75"/>
                                  </svg>
                                </div>
                                <div class="title">
                                  {{ vendorOffering?.title }}
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <!--<div class="rm-flx-col">
                       <div class="free-plan-sec">
                        <div class="free-plan-promo"
                         *ngIf="ratePlan?.promotionData?.freeStayPromotionData?.title">
                         <app-text-clamp-shell
                           [config]="{ data: (ratePlan?.promotionData?.freeStayPromotionData?.title), row: 2 }">
                         </app-text-clamp-shell>
                       </div>
                       </div>
                     </div>-->

                    </div>
                  </div>
                  <div class="pr-rm-amt">
                    <div class="pr-flex-wrap">
                      @if (ratePlan?.promotionData?.earnCreditPointPromotion?.title) {
                        <div class="pr-plan">
                          <div class="earn-plan-promo">
                            <app-text-clamp-shell
                              [config]="{
                                data: ratePlan?.promotionData
                                  ?.earnCreditPointPromotion?.title,
                                row: 2,
                              }"
                            >
                            </app-text-clamp-shell>
                          </div>
                        </div>
                      }
                      <div class="pr-dt-plan">
                        <div class="pr-dt-inner-wrap">
                          @if (!ratePlan?.priceCheckFailed) {
                            <div class="pr-dt">
                              <div class="dis-amt">
                                @for (priceDetail of ratePlan?.priceDetails;
                                  track priceDetail;
                                  let last = $last;
                                  let first = $first) {
                                  <span
                                    class="pr-amt"
                                    [ngClass]="{
                                      'cross-dis': last,
                                      dis: !last,
                                    }"
                                  >
                                    @if (first || last) {
                                      {{ priceDetail?.title }}
                                    }
                                  </span>
                                }
                              </div>
                              <div class="pr-amt-dt">{{ ratePlan?.info }}</div>
                              @if (ratePlan?.promotionData
                                ?.appliedMembershipDiscountPromotionData
                                ?.title) {
                                <div class="spl-dis">
                                  <span>
                                    <svg
                                      y="0px"
                                      width="13"
                                      height="13"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        d="M 12 2 C 6.486 2 2 6.486 2 12 C 2 17.514 6.486 22 12 22 C 17.514 22 22 17.514 22 12 C 22 10.874 21.803984 9.7942031 21.458984 8.7832031 L 19.839844 10.402344 C 19.944844 10.918344 20 11.453 20 12 C 20 16.411 16.411 20 12 20 C 7.589 20 4 16.411 4 12 C 4 7.589 7.589 4 12 4 C 13.633 4 15.151922 4.4938906 16.419922 5.3378906 L 17.851562 3.90625 C 16.203562 2.71225 14.185 2 12 2 z M 21.292969 3.2929688 L 11 13.585938 L 7.7070312 10.292969 L 6.2929688 11.707031 L 11 16.414062 L 22.707031 4.7070312 L 21.292969 3.2929688 z"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span>{{
                                      ratePlan?.promotionData
                                        ?.appliedMembershipDiscountPromotionData
                                        ?.title
                                    }}</span>
                                </div>
                              }
                              @if (ratePlan?.promotionData
                                ?.appliedBag2bagInternalDiscountPromotionData
                                ?.title) {
                                <div class="spl-dis">
                                  <span>
                                    <svg
                                      y="0px"
                                      width="13"
                                      height="13"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        d="M 12 2 C 6.486 2 2 6.486 2 12 C 2 17.514 6.486 22 12 22 C 17.514 22 22 17.514 22 12 C 22 10.874 21.803984 9.7942031 21.458984 8.7832031 L 19.839844 10.402344 C 19.944844 10.918344 20 11.453 20 12 C 20 16.411 16.411 20 12 20 C 7.589 20 4 16.411 4 12 C 4 7.589 7.589 4 12 4 C 13.633 4 15.151922 4.4938906 16.419922 5.3378906 L 17.851562 3.90625 C 16.203562 2.71225 14.185 2 12 2 z M 21.292969 3.2929688 L 11 13.585938 L 7.7070312 10.292969 L 6.2929688 11.707031 L 11 16.414062 L 22.707031 4.7070312 L 21.292969 3.2929688 z"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span>{{
                                      ratePlan?.promotionData
                                        ?.appliedBag2bagInternalDiscountPromotionData
                                        ?.title
                                    }}</span>
                                </div>
                              }
                            </div>
                          }
                          <div class="err-msg">
                            {{ ratePlan?.errorInfo }}
                          </div>
                          <div class="btn-opn">
                            @if (roomData?.roomPlanData?.availableRooms &&
                            !ratePlan?.priceCheckFailed) {
                              <div class="select-room">
                                @if (ratePlan?.selectedRooms?.length > 0) {
                                  <div>
                                    <button
                                      (click)="
                                        removeSelectedRatePlan(
                                          roomData,
                                          ratePlan,
                                          ratePlanIndex
                                        )
                                      "
                                      class="remove-btn"
                                    >
                                      Remove
                                    </button>
                                  </div>
                                }
                                @if (!ratePlan?.selectedRooms ||
                                ratePlan?.selectedRooms?.length === 0) {
                                  <div>
                                    <button
                                      (click)="
                                        selectRatePlan(
                                          roomData,
                                          ratePlan,
                                          ratePlanIndex,
                                          roomIndex
                                        )
                                      "
                                      class="select-btn"
                                      [disabled]="roomData?.disableAddRoom"
                                    >
                                      @if (ratePlan?.entireProperty) {
                                        Select Entire
                                        {{ ratePlan?.entityTitle | titlecase }}
                                      }
                                      @if (!ratePlan?.entireProperty) {
                                        Select
                                        {{ ratePlan?.entityTitle | titlecase }}
                                      }
                                    </button>
                                  </div>
                                }
                              </div>
                            }
                            @if (!roomData?.roomPlanData?.availableRooms ||
                            ratePlan?.priceCheckFailed) {
                              <div class="sold-out-btn">
                                <div class="title">SOLD OUT</div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <!-- <div class="mem-wrap">
                      <div *ngIf="ratePlan?.promotionData?.membershipPromotion?.title" class="mem-plan-promo">
                        <app-text-clamp-shell
                          [config]="{ data: (ratePlan?.promotionData?.membershipPromotion?.title), row: 2 }">
                        </app-text-clamp-shell>
                      </div>
                    </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="promo-div" [ngClass]="{
                  'd-none':
                    selectedRatePlanFilter?.key &&
                    selectedRatePlanFilter?.key !== ratePlan?.ratePlanType &&
                    (!ratePlan?.selectedRooms || ratePlan?.selectedRooms?.length === 0)
                }">
              @if (ratePlan?.promotionData?.membershipPromotion?.title) {
                <div class="title">
                  <app-text-clamp-shell
                    [config]="{
                      data: ratePlan?.promotionData?.membershipPromotion?.title,
                      row: 2,
                    }"
                  >
                  </app-text-clamp-shell>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #roomAndPropertyTemplate
  let-roomData="roomData"
  let-isFullDetail="isFullDetail"
>
  @let sliceValue = isFullDetail ? 20 : 1;
  <!--@if (roomData?.roomPlanData?.roomFilters?.propertyViews?.length > 0) {
    @for (item of roomData?.roomPlanData?.roomFilters?.propertyViews | slice: 0 : sliceValue; track item?.name) {
      <div class="rm-amen-lst view-icon">
        <ng-container
          *ngTemplateOutlet="roomDetailTemplate; context: { title: item?.name, icon: 'view' }"
        ></ng-container>
      </div>
    }
  } @else {
    @if (roomData?.roomPlanData?.roomFilters?.propertyView) {
      <div class="rm-amen-lst view-icon">
        <ng-container
          *ngTemplateOutlet="roomDetailTemplate; context: { title: roomData?.roomPlanData?.roomFilters?.propertyView, icon: 'view' }"
        ></ng-container>
      </div>
    }
  }-->

  @if (roomData?.roomPlanData?.entirePropertyDetails;
    as entirePropertyDetails) {
    <div class="rm-amen-lst">
      @if (entirePropertyDetails?.roomCount) {
        <div>
          <ng-container
            *ngTemplateOutlet="
              roomDetailTemplate;
              context: { title: entirePropertyDetails?.roomCount, icon: 'room' }
            "
          ></ng-container>
        </div>
      }
      @if (entirePropertyDetails?.bedTypes) {
        <div>
          <ng-container
            *ngTemplateOutlet="
              roomDetailTemplate;
              context: { title: entirePropertyDetails?.bedTypes, icon: 'bed' }
            "
          ></ng-container>
        </div>
      }
    </div>
  }

  @if (!roomData?.roomPlanData?.entirePropertyDetails || isFullDetail) {
    @if (roomData?.roomPlanData?.roomFilters?.roomDetails; as roomDetails) {
      @for (roomDetail of roomDetails | slice: 0 : sliceValue;
        track roomDetail;
        let rdIndex = $index) {
        <div [ngClass]="{ 'multi-room': roomDetails?.length > 1 }">
          @if (roomDetails?.length > 1) {
            <div class="rm-hd">Room {{ rdIndex + 1 }}</div>
          }
          <div class="rm-amen-lst">
            @if (roomDetail?.bathRoom?.length > 0) {
              @for (brDetail of roomDetail?.bathRoom | slice: 0 : sliceValue;
                track brDetail?.name) {
                @if (brDetail?.count > 0) {
                  <ng-container
                    *ngTemplateOutlet="
                      roomDetailTemplate;
                      context: {
                        title: brDetail?.count + ' ' + brDetail?.name,
                        icon: 'bathroom',
                      }
                    "
                  ></ng-container>
                }
              }
            } @else {
              @if (roomDetail?.bathRooms) {
                <ng-container
                  *ngTemplateOutlet="
                    roomDetailTemplate;
                    context: { title: roomDetail?.bathRooms, icon: 'bathroom' }
                  "
                ></ng-container>
              }
            }

            @if (roomDetail?.bedType?.length > 0) {
              @for (item of roomDetail?.bedType | slice: 0 : sliceValue;
                track item?.name) {
                @if (item?.count > 0) {
                  <ng-container
                    *ngTemplateOutlet="
                      roomDetailTemplate;
                      context: {
                        title: item?.count + ' ' + item?.name,
                        icon: 'bed',
                      }
                    "
                  ></ng-container>
                }
              }
            } @else {
              @if (roomDetail?.bedTypes) {
                <ng-container
                  *ngTemplateOutlet="
                    roomDetailTemplate;
                    context: { title: roomDetail?.bedTypes, icon: 'bed' }
                  "
                ></ng-container>
              }
            }

            @if (roomDetail?.roomSizeData?.value) {
              <ng-container
                *ngTemplateOutlet="
                  roomDetailTemplate;
                  context: {
                    title:
                      roomDetail?.roomSizeData?.value +
                      ' ' +
                      roomDetail?.roomSizeData?.unit,
                    icon: 'room-size',
                  }
                "
              ></ng-container>
            } @else {
              @if (roomDetail?.roomSize) {
                <ng-container
                  *ngTemplateOutlet="
                    roomDetailTemplate;
                    context: { title: roomDetail?.roomSize, icon: 'room-size' }
                  "
                ></ng-container>
              }
            }

            @if (roomDetail?.roomViews?.length > 0) {
              @for (item of roomDetail?.roomViews | slice: 0 : sliceValue;
                track item?.name) {
                <ng-container
                  *ngTemplateOutlet="
                    roomDetailTemplate;
                    context: { title: item?.name, icon: 'view' }
                  "
                ></ng-container>
              }
            }
          </div>
        </div>
      }
    }
  }
</ng-template>

<ng-template #roomDetailTemplate let-title="title" let-icon="icon">
  <div class="rm-am-blk">
    <div class="rm-am-img-wrap">
      <div class="rm-am-img">
        @switch (icon) {
          @case ("room") {
            <svg
              height="32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 632.5 945.9"
              stroke="#3a3a3a"
            >
              <path
                fill="#3a3a3a"
                d="M4,454.3v487.9c0,0,304.4,0,304.4,0h321.6V3.2H4v451.1h0ZM509.7,39.6c2.4.9-24,10.4-71.2,25.9-41.5,13.4-97.8,31.7-125.2,40.6l-50.3,16.4v745.2l90.7,18.1c49.9,9.9,90.7,18.4,90.7,18.8s-90.9.9-201.8.9H40.7v-432.4c0-237.9.4-433,1.1-433.7,1.7-1.7,463.5-1.5,468,.2h0ZM592.6,896.2c-.4.2-66.3-12.5-146.4-28.5-79.9-16-145.7-29.1-145.9-29.1-.4,0-.7-155.4-.7-345.2V148l27.6-8.6c15.1-4.8,81-26.1,146.1-47.5l118.7-38.7.7,421.1c.2,231.6.2,421.4-.2,421.8Z"
              />
              <path fill="#3a3a3a" d="M319.1,536.3v17.3h54v-34.5h-54v17.3Z"/>
            </svg>
          }
          @case ("bed") {
            <svg
              width="29"
              height="18"
              viewBox="0 0 46 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                d="M8.23742 15.95C6.48322 15.9549 4.80235 16.6096 3.56194 17.7713C2.32152 18.933 1.62237 20.5072 1.61719 22.15V33V32.225C1.6191 31.6089 1.88127 31.0186 2.34643 30.583C2.81159 30.1473 3.44194 29.9018 4.09978 29.9H42.1661C42.824 29.9018 43.4543 30.1473 43.9195 30.583C44.3846 31.0186 44.6468 31.6089 44.6487 32.225V33V22.15C44.6435 20.5072 43.9444 18.933 42.704 17.7713C41.4636 16.6096 39.7827 15.9549 38.0285 15.95M8.23742 15.95H38.0285M8.23742 15.95V14.4C8.23988 13.5785 8.58941 12.7914 9.20965 12.2105C9.82988 11.6296 10.6704 11.3023 11.5475 11.3H19.8228C20.7 11.3023 21.5405 11.6296 22.1607 12.2105C22.781 12.7914 23.1305 13.5785 23.133 14.4M38.0285 15.95V14.4C38.026 13.5785 37.6765 12.7914 37.0563 12.2105C36.436 11.6296 35.5955 11.3023 34.7184 11.3H26.4431C25.5659 11.3023 24.7254 11.6296 24.1052 12.2105C23.4849 12.7914 23.1354 13.5785 23.133 14.4M23.133 14.4V15.95M6.58236 15.95V5.875C6.58564 4.84823 7.02262 3.86439 7.79787 3.13835C8.57312 2.41231 9.62365 2.00307 10.72 2H35.5459C36.6423 2.00307 37.6928 2.41231 38.468 3.13835C39.2433 3.86439 39.6803 4.84823 39.6835 5.875V15.95H6.58236Z"
                stroke="#636363"
                stroke-width="2.46154"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          @case ("bathroom") {
            <svg
              width="28"
              height="18"
              viewBox="0 0 43 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                d="M38.3204 13.0769H11.3971V11.7692C11.3971 9.60599 9.55476 7.84611 7.29019 7.84611H5.92127V3.92305C5.92127 3.202 6.53542 2.61534 7.29027 2.61534C8.04513 2.61534 8.65928 3.202 8.65928 3.92305C8.65928 4.64521 9.27221 5.23077 10.0283 5.23077C10.7844 5.23077 11.3973 4.64529 11.3973 3.92305C11.3973 1.75988 9.55493 0 7.29036 0C5.02579 0 3.18341 1.75988 3.18341 3.92305C3.18341 4.83953 3.18341 12.3589 3.18341 13.3017C1.58998 13.8416 0.445312 15.2951 0.445312 16.9999C0.445312 18.7047 1.58998 20.1581 3.18325 20.698V22.2305C3.18325 26.1735 5.80655 29.5421 9.47351 30.8276L8.80368 32.1072C8.46553 32.7532 8.73972 33.5387 9.41586 33.8616C10.0916 34.1845 10.9143 33.923 11.2526 33.2768L12.2502 31.371C12.4211 31.3797 12.5931 31.3844 12.7661 31.3844H30.1066C30.2796 31.3844 30.4517 31.3797 30.6225 31.371L31.6202 33.2768C31.9588 33.9239 32.782 34.1842 33.4569 33.8616C34.1332 33.5387 34.4072 32.7532 34.0691 32.1072L33.3993 30.8276C37.0661 29.5422 39.6894 26.1735 39.6894 22.2306V20.698C41.2828 20.1582 42.4273 18.7047 42.4273 16.9999C42.4274 14.8368 40.585 13.0769 38.3204 13.0769ZM5.92127 10.4615H7.29027C8.04513 10.4615 8.65928 11.0481 8.65928 11.7692V13.0769H5.92127V10.4615ZM36.9514 22.2306C36.9514 25.8359 33.8808 28.769 30.1065 28.769H12.7661C8.99186 28.769 5.92127 25.8359 5.92127 22.2306V20.9229H36.9515L36.9514 22.2306ZM38.3204 18.3075H4.55226C3.7974 18.3075 3.18325 17.7208 3.18325 16.9998C3.18325 16.2787 3.7974 15.6921 4.55226 15.6921C6.12814 15.6921 36.7318 15.6921 38.3204 15.6921C39.0753 15.6921 39.6894 16.2787 39.6894 16.9998C39.6894 17.7209 39.0753 18.3075 38.3204 18.3075Z"
                fill="#636363"
              />
            </svg>
          }
          @case ("room-size") {
            <svg
              width="22"
              height="15"
              viewBox="0 0 27 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                d="M2.025 16C1.485 16 1.0125 15.8 0.6075 15.4C0.2025 15 0 14.5333 0 14V2C0 1.48889 0.2025 1.02778 0.6075 0.616667C1.0125 0.205556 1.485 0 2.025 0H24.975C25.515 0 25.9875 0.205556 26.3925 0.616667C26.7975 1.02778 27 1.48889 27 2V14C27 14.5333 26.7975 15 26.3925 15.4C25.9875 15.8 25.515 16 24.975 16H2.025ZM2.025 14H24.975V2H20.5875V8H18.5625V2H14.5125V8H12.4875V2H8.4375V8H6.4125V2H2.025V14Z"
                fill="#636363"
              ></path>
            </svg>
          }
          @case ("view") {
            <svg
              width="20"
              height="18"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                d="M1.75 21C1.26389 21 0.850694 20.8299 0.510417 20.4896C0.170139 20.1493 0 19.7361 0 19.25V1.75C0 1.26389 0.170139 0.850694 0.510417 0.510417C0.850694 0.170139 1.26389 0 1.75 0H19.25C19.7361 0 20.1493 0.170139 20.4896 0.510417C20.8299 0.850694 21 1.26389 21 1.75V19.25C21 19.7361 20.8299 20.1493 20.4896 20.4896C20.1493 20.8299 19.7361 21 19.25 21H1.75ZM11.375 11.375V19.25H19.25V11.375H11.375ZM11.375 9.625H19.25V1.75H11.375V9.625ZM9.625 9.625V1.75H1.75V9.625H9.625ZM9.625 11.375H1.75V19.25H9.625V11.375Z"
                fill="#636363"
              />
            </svg>
          }
        }
      </div>
      <div class="title">{{ title | titlecase }}</div>
    </div>
  </div>
</ng-template>

<ng-template #roomTypeFilterTemplate>
  @if (compData?.container?.roomContainers?.length > 1) {
    <div class="filter-cls">
      <div>
        <div class="room-title">Room Types</div>
      </div>
      <select [(ngModel)]="scrollToRoom"
              (ngModelChange)="gotoRoom($event)"
              class="filter-sel">
        <option [ngValue]="null">Please select</option>
        @for (option of compData?.container?.roomContainers; track option) {
          <option [ngValue]="option">
            {{
              option?.roomPlanData?.channelManagerDisplayCategory | titlecase
            }}
          </option>
        }
      </select>
    </div>
  }
</ng-template>

<ng-template #ratePlanFilterTemplate>
  @if (compData?.container?.ratePlanFilters?.length > 1) {
    <div class="ftrWrp">
      <div class="rp-ftr">
        <div class="ftr-head">Filter by</div>
        <div class="rp-scroll">
          @for (ratePlanFilter of compData?.container?.ratePlanFilters;
            track ratePlanFilter?.key) {
            <div class="rp-ftr-lp"
                 (click)="onRatePlanFilter(ratePlanFilter)"
                 [ngClass]="{
                'selected-rpf': ratePlanFilter?.key === selectedRatePlanFilter?.key,
             }"
            >
              <div class="rpf-val">{{ ratePlanFilter?.value }}</div>
              @if (ratePlanFilter?.key === selectedRatePlanFilter?.key) {
                <div class="cls-ico">
                  <div class="cls-img">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="#2697ff" class="size-4">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
                    </svg>
                  </div>
                </div>
              }
            </div>
          }
          <!--<div class="rstBtnWrp">
            <button class="rst-btn" (click)="onRatePlanFilter(null)">Reset</button>
          </div>-->
        </div>
      </div>

    </div>
  }
</ng-template>

@if (!isServer) {
  <ion-modal
    #individualRoomModal
    class="desktop-room-view-detail-modal"
    (willDismiss)="onIndividualModalWillDismiss($event)"
  >
    <ng-template>
      <div class="header">
        <div class="flex-container ion-justify-content-between ion-align-items-center">
          <div class="flex-container ion-align-items-center hdr-box">
            <div class="back-icon" (click)="dismissIndividualRoomModal()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"/>
              </svg>
            </div>
            <div class="title">
              {{
                selectedRoomContainer?.roomPlanData
                  ?.channelManagerDisplayCategory
                  | displayCategoryPipe
                  | titlecase
              }}
              Details
            </div>
          </div>
          <div class="close-icon" (click)="dismissIndividualRoomModal()">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
              <path fill="#cb0620"
                    d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"
              ></path>
            </svg>
          </div>
        </div>
      </div>
      <ion-content>
        <div class="rm-details">
          <div class="rm-dt-inr-wp">
            <div class="rm-dt-rd">
              <ng-container
                *ngTemplateOutlet="
                  roomCardTemplate;
                  context: {
                    roomData: selectedRoomContainer,
                    roomIndex: selectedRoomContainerIndex,
                    cardStyle: 'ind-room',
                    isFullDetail: true,
                  }
                "
              ></ng-container>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="cartTemplate"></ng-container>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>


  <ion-modal
    #multipleRoomWarningModal
    class="multipleRoomWarningModal"
    [backdropDismiss]="false"
  >
    <ng-template>
      <!--<div class="header">
        <div class="flex-container ion-justify-content-between ion-align-items-center">
          <div class="flex-container ion-align-items-center hdr-box">
            <div class="title">
              Do you want to add multiple rooms?
            </div>
          </div>
        </div>
      </div>-->
      <ion-content>
        <div class="mlt-rm-pty">
          <div class="title">
            <!--Do you want to add multiple rooms?--> {{ multiRoomWarningContainer?.title }}
          </div>
          <div class="flex-container ion-align-items-center ion-justify-content-end btn-sec">
            <button class="y-btn btn" (click)="addMultipleRoom(true)">Yes</button>
            <button class="n-btn btn" (click)="addMultipleRoom(false)">No</button>
          </div>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
}
